<template>
  <div id="one-tap-container" class="one-tap-container" />
</template>

<script setup lang="ts">
import { useGoogleSignIn } from '~/composables/useGoogleSignIn'

const { initializeGoogleSignIn, isInitialized, isLoggedIn } = useGoogleSignIn()
const isOneTapDisplayed = ref(false)

// FedCM Note: Removed moment notification callback for full compliance
// FedCM provides browser-native UI that doesn't require custom moment tracking

// Determine if One Tap should be shown
const shouldShowOneTap = computed(() => {
  if (!isInitialized.value) return false
  if (isLoggedIn.value) return false
  // Don't show One Tap in mobile iframes (can cause UX issues)
  if (
    import.meta.client &&
    window.self !== window.top &&
    window.innerWidth < 768
  ) {
    return false
  }
  return true
})

// Show One Tap when appropriate
function showOneTap() {
  if (shouldShowOneTap.value && window.google?.accounts?.id?.prompt) {
    // Set flag to track that One Tap is displayed
    isOneTapDisplayed.value = true

    // FedCM: Call prompt without moment callback for full compliance
    try {
      window.google.accounts.id.prompt()
    } catch {
      // Don't throw - this is non-critical UX enhancement
      isOneTapDisplayed.value = false
    }
  }
}

// Watch for initialization to complete
watch(isInitialized, (initialized) => {
  if (initialized) {
    void showOneTap()
  }
})

onMounted(async () => {
  await nextTick(async () => {
    try {
      await initializeGoogleSignIn()
    } catch {
      // Initialization failure is non-critical for One Tap
    }
  })
})

onUnmounted(() => {
  if (
    isOneTapDisplayed?.value &&
    window &&
    window.google?.accounts?.id?.cancel
  ) {
    try {
      window.google.accounts.id.cancel()
    } catch {
      // Cancellation errors are non-critical during unmount
    }
  }
})
</script>

<style scoped>
.one-tap-container {
  position: relative;
  z-index: 1000;
}
</style>
